// src/services/tagApiService.ts
import { DefaultApi, Configuration } from "tag-api-client";
import { fetchAuthSession } from "aws-amplify/auth";

class TagApiService {
    private api: DefaultApi;
    private basePath: string;

    constructor() {
        this.basePath =
            "https://phgfsenpnj.execute-api.eu-west-1.amazonaws.com";
        this.api = new DefaultApi(
            new Configuration({
                basePath: this.basePath,
            })
        );
    }

    private async getAuthHeaders(): Promise<HeadersInit> {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        return {
            // THIS! Specify the content type or it will default to text/plain and fail!!!
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };
    }

    async listTags() {
        try {
            const headers = await this.getAuthHeaders();
            const response = await this.api.v1Get({ headers });
            return response.tags || [];
        } catch (error) {
            console.error("listTags error:", error);
            throw error;
        }
    }

    async createTag(keyValue: string) {
        try {
            const headers = await this.getAuthHeaders();
            const response = await this.api.v1Post(
                { createTagRequest: { keyValue } },
                { headers }
            );
            return response.tag;
        } catch (error) {
            console.error("createTag error:", error);
            throw error;
        }
    }

    async deleteTag(tagId: string) {
        try {
            const headers = await this.getAuthHeaders();
            await this.api.v1TagIdDelete({ tagId }, { headers });
        } catch (error) {
            console.error("deleteTag error:", error);
            throw error;
        }
    }

    async updateTag(tagId: string, keyValue: string) {
        try {
            const headers = await this.getAuthHeaders();
            await this.api.v1TagIdPut(
                { tagId, updateTagRequest: { keyValue } },
                { headers }
            );
        } catch (error) {
            console.error("updateTag error:", error);
            throw error;
        }
    }
}

export const tagApiService = new TagApiService();
